<template>
  <div class="circular-progress-container">
    <svg class="circular-progress" :width="size" :height="size" viewBox="0 0 120 120">
      <!-- Background circle -->
      <circle
        class="progress-bg"
        cx="60"
        cy="60"
        :r="radius"
        fill="none"
        :stroke-width="strokeWidth"
      />
      <!-- Progress circle -->
      <circle
        class="progress-bar"
        cx="60"
        cy="60"
        :r="radius"
        fill="none"
        :stroke-width="strokeWidth"
        :stroke-dasharray="circumference"
        :stroke-dashoffset="strokeDashoffset"
        :style="{ stroke: progressColor }"
      />
    </svg>
    <div class="progress-text">
      <div class="progress-value">{{ value }}</div>
      <div class="progress-label">{{ label }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CircularProgress',
  props: {
    value: {
      type: Number,
      required: true,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    label: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 120
    },
    strokeWidth: {
      type: Number,
      default: 8
    }
  },
  computed: {
    radius() {
      return 50;
    },
    circumference() {
      return 2 * Math.PI * this.radius;
    },
    strokeDashoffset() {
      const progress = this.value / this.max;
      return this.circumference * (1 - progress);
    },
    progressColor() {
      const percentage = (this.value / this.max) * 100;
      if (percentage >= 80) return '#6BAB90';
      if (percentage >= 50) return '#f59e0b';
      return '#d23838';
    }
  }
}
</script>

<style scoped>
.circular-progress-container {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.circular-progress {
  transform: rotate(-90deg);
}

.progress-bg {
  stroke: var(--color-divider);
  opacity: 0.3;
}

.progress-bar {
  stroke-linecap: round;
  transition: stroke-dashoffset 1s ease-in-out, stroke 0.3s ease;
}

.progress-text {
  position: absolute;
  text-align: center;
}

.progress-value {
  font-size: 2rem;
  font-weight: 700;
  font-family: 'Oxanium', 'Inter', sans-serif;
  color: var(--text-primary);
  line-height: 1;
}

.progress-label {
  font-size: 0.75rem;
  color: var(--text-muted);
  margin-top: 0.25rem;
  text-transform: capitalize;
}
</style>